// extracted by mini-css-extract-plugin
module.exports = {"controls":"Controls_controls__1m6Vw","SimulatorControls":"Controls_SimulatorControls__3xwzo","PlotControls":"Controls_PlotControls__3OwH_"};